<!-- @format -->

<template>
    <div class="gst-hotel-no-data px-md-10 py-md-12">
        <h5>{{ $t('title') }}</h5>
        <p>{{ $t('message') }}</p>
        <a
            href="#"
            class="d-inline-block"
            @click="$emit('reset-filters')">
            {{ $t('_common:buttons.resetFilters').toLowerCase() }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'HotelsNoData',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.addHotelReservation._components.hotelsNoData',
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-hotel-no-data {
    line-height: normal;
    text-align: center;

    h5 {
        padding-bottom: theme-spacing(2);
        font-size: font-size('xxxxxl');
        font-weight: font-weight('large');
    }

    p {
        margin-bottom: theme-spacing(6);
        font-size: font-size('l');
        font-weight: font-weight('regular');
    }

    a {
        font-size: font-size('l');
        text-transform: capitalize;
    }
}

@include mobile-only {
    .gst-hotel-no-data {
        padding: theme-spacing(14, 5, 0, 5);

        h5 {
            @include font-size('xxxxl');
            @include font-weight('large');
        }
    }
}
</style>
